import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

type BrandLogoProps = {
    to?: string;
    subLabel?: string;
    dark?: boolean;
    compact?: boolean;
};

export function BrandLogo({ to = "/", subLabel, dark = false, compact = false }: BrandLogoProps) {
    const titleClass = dark ? "text-white" : "text-brand-forest";
    const subClass = dark ? "text-brand-yellow" : "text-brand-green";

    return (
        <Link to={to} className="flex items-center gap-3" aria-label="Green Unison home">
            {compact ? (
                <StaticImage
                    src="../../images/gu-logo.png"
                    alt="Green Unison"
                    width={44}
                    height={44}
                    layout="fixed"
                    placeholder="blurred"
                    formats={["auto", "webp", "avif"]}
                    className="rounded-full shadow-brand"
                />
            ) : (
                <StaticImage
                    src="../../images/gu-logo.png"
                    alt="Green Unison"
                    width={56}
                    height={56}
                    layout="fixed"
                    placeholder="blurred"
                    formats={["auto", "webp", "avif"]}
                    className="rounded-full shadow-brand"
                />
            )}

            <span>
                <span className={`block text-base font-black tracking-tight ${titleClass}`}>
                    Green Unison
                </span>

                {subLabel ? (
                    <span
                        className={`block text-xs font-extrabold uppercase tracking-[0.22em] ${subClass}`}
                    >
                        {subLabel}
                    </span>
                ) : null}
            </span>
        </Link>
    );
}
